<template lang="">
  <v-card class="d-flex justify-space-between align-center my-4 pa-5 border" outlined>
    <v-row no-gutters>
      <v-col cols="12" :lg="router !== 'main' ? 3 : 5" :md="router !== 'main' ? 6 : 4">
        <span> {{ titleType }} </span>
        <h4 class="text-truncate" style="max-width: 350px">
          {{ headFee.title }}
        </h4>
      </v-col>
      <v-col cols="12" lg="3" :md="router !== 'main' ? 6 : 4" v-if="router !== 'main'">
        <span>
          Áp dụng với khoản phí thu đóng
        </span>
        <h4>
          {{ headFee.head_fee_apply && headFee.head_fee_apply.title }}
        </h4>
      </v-col>
      <v-col cols="12" lg="2" :md="router === 'adjust' ? 6 : 4" v-if="router === 'adjust'">
        <span>
          Phân loại
        </span>
        <h4>
          {{ headFee.type === 'sum' ? 'Thưởng' : 'Phạt' }}
        </h4>
      </v-col>
      <v-col cols="12" :lg="router !== 'main' ? 2 : 5" :md="router !== 'main' ? 6 : 4">
        <span>
          Ghi chú
        </span>
        <v-tooltip max-width="300px" bottom>
          <template v-slot:activator="{ on, attrs }">
            <h4 v-bind="attrs" v-on="on" class="note text-truncate">
              {{ headFee.note ? headFee.note : '' }}
            </h4>
          </template>
          <span class="tooltip white--text">{{ headFee.note ? headFee.note : '' }}</span>
        </v-tooltip>
      </v-col>
      <v-col cols="12" lg="2" md="12" class="detail d-flex justify-end align-center">
        <InfoDialog :headFee="headFee" />
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
import { mapState } from 'vuex'
import InfoDialog from './info-dialog/InfoDialog.vue'
export default {
  components: {
    InfoDialog
  },
  data() {
    return {
      detailDialog: false
    }
  },
  computed: {
    ...mapState('salaryHead', ['router', 'isSubFee', 'headFee']),
    titleType() {
      return this.$route.meta.title.replace('Chi tiết', '')
    }
  }
}
</script>
<style lang="scss" scoped>
span {
  font-size: 14px;
  color: #797979;
}
h4 {
  font-size: 18px;
  font-weight: 500;
}
.tooltip {
  word-wrap: break-word;
}
.btn-color {
  background-color: white !important;
}
h4.note {
  max-width: 280px;
}
@media screen and (max-width: 1264px) {
  .detail {
    padding-top: 30px;
  }
}
@media screen and (max-width: 626px) {
  h4.note {
    max-width: 250px;
  }
}
</style>
